import { Box, Image } from "@chakra-ui/react";
import { useState } from "react";
import { CountryEnum } from "src/api/generated/types";
import { colors } from "src/theme";
import { COUNTRIES } from "src/views/client/Settings";
import styled from "styled-components";
import { AwakenTooltip } from "../styled";

// Using the same countries from Settings
const COUNTRIES_FLAGS = [
  {
    label: "United States",
    value: CountryEnum.Us,
    flag: "🇺🇸",
    image: "https://assets.awaken.tax/icons/us.png",
  },
  {
    label: "Canada",
    value: CountryEnum.Ca,
    flag: "🇨🇦",
    image: "https://assets.awaken.tax/icons/canada.jpg",
  },
  {
    label: "Australia",
    value: CountryEnum.Au,
    flag: "🇦🇺",
    image: "https://assets.awaken.tax/icons/au.png",
  },
  {
    label: "Germany",
    value: CountryEnum.De,
    flag: "🇩🇪",
    image: "https://assets.awaken.tax/icons/de.png",
  },
];

const COUNTRIES_SET = new Set(COUNTRIES_FLAGS.map((c) => c.value));

const CircleContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
`;

interface FlagCircleProps {
  isMore?: boolean;
  index?: number;
  isHovered?: boolean;
}

const FlagCircle = styled(Box)<FlagCircleProps>`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: ${(props) => (props.isMore ? colors.primary : colors.white)};
  border: 2px solid
    ${(props) => (props.isMore ? colors.primary : colors.gray10)};
  margin: -6px;
  transition: transform 0.2s;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${(props) => (props.isMore ? "12px" : "22px")};
  color: ${(props) => (props.isMore ? colors.white : "inherit")};
  font-weight: ${(props) => (props.isMore ? "600" : "normal")};
  overflow: hidden;
  z-index: ${(props) =>
    props.isHovered ? 100 : COUNTRIES_FLAGS.length - (props.index || 0)};

  &:hover {
    transform: scale(1.1);
    z-index: 100;
    border-color: ${colors.primary};
  }
`;

const FlagImage = ({ src, fallback }: { src: string; fallback: string }) => {
  const [error, setError] = useState(false);

  if (error) {
    return <span>{fallback}</span>;
  }

  return (
    <Image
      src={src}
      alt="flag"
      width="100%"
      height="100%"
      objectFit="cover"
      onError={() => setError(true)}
    />
  );
};

export const CountryCircles = () => {
  return (
    <CircleContainer>
      {COUNTRIES_FLAGS.map((country, index) => (
        <AwakenTooltip key={country.value} message={country.label}>
          <FlagCircle index={index}>
            <FlagImage src={country.image} fallback={country.flag} />
          </FlagCircle>
        </AwakenTooltip>
      ))}
      <AwakenTooltip
        message={`And more like ${COUNTRIES.filter(
          (c) => !COUNTRIES_SET.has(c.value)
        )
          .map((c) => c.label)
          .join(", ")}.`}
      >
        <FlagCircle isMore index={COUNTRIES_FLAGS.length}>
          <i style={{ fontSize: 24 }} className="fa-sharp fa-globe" />
        </FlagCircle>
      </AwakenTooltip>
    </CircleContainer>
  );
};
